import { useEffect } from 'react';

import { Helmet } from 'react-helmet';
import { Outlet, ScrollRestoration } from 'react-router-dom';

import { useTheme } from '../../services/state/theme-state.jsx';

export const CustomerPortalWrapper = () => {
  const { setTheme } = useTheme();

  useEffect(() => {
    setTheme('light');
  }, []);

  return (
    <>
      <Helmet>
        <title>Portal de Campanhas - MAR SHOPPING</title>
      </Helmet>
      <ScrollRestoration />
      <Outlet />
    </>
  );
};

export default CustomerPortalWrapper;
